export default __webpack_public_path__ + "static/globe-blue-2d455a781d12d7344eb7d42eacd5a5a6.svg";